import { MarketingChannel } from "@redotech/redo-model/marketing";
import { SortDirection } from "@redotech/redo-model/tables/table";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getMarketingAgentConversationLogs = {
  name: "getMarketingAgentConversationLogs" as const,
  input: z.object({
    page: z.number().int().positive().default(1),
    pageSize: z.number().int().positive().max(100).default(20),
    sortKey: z
      .enum(["lastMessageAt", "lastInitialMessageAt"])
      .default("lastMessageAt"),
    sortDirection: createEnum(SortDirection).default(SortDirection.DESC),
    searchString: z.string().optional(),
  }),
  output: z.object({
    conversations: z.array(
      z.object({
        _id: z.string(),
        customerId: z.string(),
        customerName: z.string().optional(),
        lastMessageAt: z.date().optional(),
        lastInitialMessageAt: z.date().optional(),
        messageCount: z.number(),
        channel: createEnum(MarketingChannel),
      }),
    ),
    totalCount: z.number(),
  }),
};
